import { mergeSx } from "@dmca/frontend/hooks";
import { Box, CircularProgress, type BoxProps } from "@mui/material";

export type DefaultPendingComponentProps = BoxProps;

export const DefaultPendingComponent: React.FC<
  DefaultPendingComponentProps
> = ({ sx, ...rest }) => {
  return (
    <Box
      sx={mergeSx(
        {
          height: "100%",
          width: "100%",
          alignSelf: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        },
        sx
      )}
      {...rest}
    >
      <CircularProgress />
    </Box>
  );
};
